var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 73,
    viewBox: "0 0 79 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3847 44.9231H61.7693V56.1539H50.5386V61.7692H61.7693V73H67.3847V61.7692H78.6155V56.1539H67.3847V44.9231Z",
    fill: "#92CDDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 11.2308H39.3077L29.7615 1.68462C28.6385 0.561538 27.2346 0 25.8308 0H5.61538C2.52692 0 0 2.52692 0 5.61538V61.7692C0 64.8577 2.52692 67.3846 5.61538 67.3846H44.9231V61.7692H5.61538V5.61538H25.8308L35.3769 15.1615L37.0615 16.8462H73V39.3077H78.6154V16.8462C78.6154 13.7577 76.0885 11.2308 73 11.2308Z",
    fill: "#92CDDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1428046f827fe343fd31f46dbd1bcb20.svg";
export { ForwardRef as ReactComponent };